export enum TextBoxType {
	Text,
	Password
}
